import { render, staticRenderFns } from "./CollectorComponent.vue?vue&type=template&id=f9b73ea8&scoped=true&"
import script from "./CollectorComponent.vue?vue&type=script&lang=js&"
export * from "./CollectorComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollectorComponent.vue?vue&type=style&index=0&id=f9b73ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b73ea8",
  null
  
)

export default component.exports